export enum KBType {
  TEXT = 'text',
  FILE = 'file',
  LINK = 'link',
  QnA = 'qa',
}
export enum EmbeddedStatus {
  PENDING = 'pending',
  COMPLETED = 'completed',
  PROCESSING = 'processing',
  FAILED = 'failed',
}

export interface KBText {
  content: string;
}
export interface KBFile {
  file_id: string;
  system_name: string;
  name: string;
  file_type: number;
  current_version: number;
  additional_properties: unknown;
  content?: string;
}

export interface KBLink {
  url: string;
  content: string;
}

export interface KBQnA {
  question: string;
  answer: string;
}

export interface KB {
  id: string;
  created_date: string;
  last_updated_date: string;
  created_by: string;
  language: string | null;
  last_updated_by: string;
  organization_ids: string[];
  tags: string[];
  kb_type: KBType;
  agent_id: string;
  file: KBFile | null;
  text: KBText | null;
  qa: KBQnA | null;
  link: KBLink | null;
  is_disabled: boolean;
  is_archived: boolean;
  embad_status: EmbeddedStatus;
  total_chunks: number;
  chunk_size: number;
  meta_data: {
    ProjectKey: string;
  };
  chunk_ext: null;
  vector_collection_name?: string;
}
